import { Flex, IconWrap, QuestionHelpCircleBoldIcon } from '@libs/ui/ds'
import type { FC } from 'react'
import React from 'react'

import { modalTooltipDef } from '../ModalTooltip/ModalTooltip'

type Props = {
  keyTooltip: string
  title: string
  titleSecondLine?: string
}

const TableHeaderColumn: FC<Props> = ({
  keyTooltip,
  title,
  titleSecondLine = undefined
}) => {
  const modalTooltipModal = modalTooltipDef.useDispatchModal()
  return (
    <Flex
      row
      className='items-center justify-center'
      onClick={() => modalTooltipModal.open({ keyTooltip })}
    >
      {titleSecondLine ? (
        <Flex className='items-center'>
          <span>{title}</span>
          <span className='text-center'>{titleSecondLine}</span>
        </Flex>
      ) : (
        title
      )}
      <IconWrap
        icon={<QuestionHelpCircleBoldIcon />}
        size='s'
        className='ml-1'
      />
    </Flex>
  )
}

export default TableHeaderColumn
